<template>
    <div>
        <div class="text-center mt-4 mb-8">
            <router-link :to="{ name: fields.route_name }" target="_blank">
                    <button type="submit" class="btn btn--half btn--green">
                        {{fields.text}}
                    </button>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'dynamic-button',
    props: {
        fields: {
            type: Object,
        },
    },
};
</script>
